import apiClient from '../../config/apiClient';

export type TimesheetStatusFilter = 'active' | 'deleted' | 'all';

export interface TimesheetListParams {
	status: TimesheetStatusFilter;
	startDate: string;
	endDate: string;
	page: number;
	size: number;
	groupId?: string;
	groupUserId?: string;
	linkedUserId?: string;
	search?: string;
}

export interface AdminTimesheet {
	_id: string;
	id: string;
	groupId: string;
	groupUserId: string;
	shiftId?: string;
	recordDate: string;
	type: string;
	timeIn: number;
	timeOut: number;
	breakTime: number;
	totalTime: number;
	note?: string;
	isDeleted: boolean;
	restoreBlockedReason?: string | null;
	updated?: string;
	synced_time?: string;
	checkinImage?: string;
	checkoutImage?: string;
	checkinLat?: number;
	checkinLng?: number;
	checkinAddress?: string;
	checkoutLat?: number;
	checkoutLng?: number;
	checkoutAddress?: string;
	group?: { id: string; name: string; code?: string };
	member?: {
		id: string;
		linkedUserId?: string;
		fname?: string;
		lname?: string;
		email?: string;
		memberCode?: string;
		lastPaidSalaryDate?: string;
	};
	shiftDetail?: { id: string; name: string };
}

export interface TimesheetGroupOption {
	id: string;
	name: string;
	code?: string;
}

export interface TimesheetMemberOption {
	id: string;
	linkedUserId?: string;
	fname?: string;
	lname?: string;
	email?: string;
	memberCode?: string;
}

const toQuery = (params: Record<string, any>) => {
	const query = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
	});
	return query.toString();
};

export const getAdminTimesheets = (params: TimesheetListParams) =>
	apiClient.get(`/admin/timesheets?${toQuery(params)}`);

export const getAdminTimesheetDetail = (timesheetId: string) =>
	apiClient.get(`/admin/timesheets/${encodeURIComponent(timesheetId)}`);

export const getAdminTimesheetGroups = (search = '') =>
	apiClient.get(`/admin/timesheets/groups?${toQuery({ search, limit: 50 })}`);

export const getAdminTimesheetMembers = (groupId: string, search = '') =>
	apiClient.get(
		`/admin/timesheets/groups/${encodeURIComponent(groupId)}/members?${toQuery({ search, limit: 100 })}`,
	);

export const restoreAdminTimesheets = (body: {
	timesheetIds: string[];
	reason: string;
	requestId: string;
}) => apiClient.post('/admin/timesheets/restore', body);
